import script from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomModal.vue?vue&type=style&index=0&id=3707cd87&lang=css"

const __exports__ = script;

export default __exports__